import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  DOC_FLOW_FORM_FIELD_TITLE,
  DOC_FLOW_FORM_TITLE_FIELD_MAX_LENGTH,
} from '../../../DocFlow.constants'

function DocFlowFormTitleField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('DocumentStapling.FormTitleFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={DOC_FLOW_FORM_TITLE_FIELD_MAX_LENGTH}
      name={DOC_FLOW_FORM_FIELD_TITLE}
      placeholder={t('DocumentStapling.FormTitleFieldPlaceholderKey')}
    />
  )
}

export default DocFlowFormTitleField
